import axios from "axios";
import React, { useCallback, useEffect, useMemo, useState } from "react";

import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import { dateInputFormatter } from "../fomatters/DateFormatter";

function GlobalSettings({ className = "", title, show }) {
  const userInfo = useMemo(
    () => JSON.parse(localStorage.getItem("userInfo")),
    []
  );

  const [open, setOpen] = useState(false);
  const handleOpenDialog = (state) => setOpen(state);

  useEffect(() => {
    setOpen(show);
  }, [show]);

  /**
   * GET
   */
  const [data, setData] = useState();
  const requestData = useCallback(() => {
    const url =
      process.env.REACT_APP_API2_URL + "/Addons/SystemBonusSetting_GetInfo";
    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        setData({
          ...data,
          LastUpdate: dateInputFormatter(data.LastUpdate),
          StartDate: dateInputFormatter(data.StartDate),
          EndDate: dateInputFormatter(data.EndDate),
        });
      });
  }, []);

  /**
   * SAVE
   */
  const saveData = useCallback(
    ({
      MaxWager,
      StartDate,
      EndDate,
      FuncStraightBets,
      FuncParlays,
      FuncTeasers,
      EnableWinBets,
      EnableLostBets,
      EnablePushBets,
      EnableNABets,
    }) => {
      axios
        .post(
          process.env.REACT_APP_API2_URL + "/Addons/SystemBonusSetting_Updates",
          {
            MaxWager: Number(MaxWager),
            StartDate,
            EndDate,
            FuncStraightBets,
            FuncParlays,
            FuncTeasers,
            EnableWinBets,
            EnableLostBets,
            EnablePushBets,
            EnableNABets,
            IdUser: Number(userInfo.userId),
          }
        )
        .then((response) => response.data)
        .then(() => requestData());
    },
    [requestData, userInfo.userId]
  );

  /**
   * Initial load
   */
  useEffect(() => {
    if (open) {
      requestData();
    }
  }, [requestData, open]);

  /**
   * Handle Change
   */
  const handleChange = useCallback(
    (event, key, value) => {
      setData({
        ...data,
        [key]: event ? event.target.value : value,
      });
    },
    [data]
  );

  if (!data) return <></>;
  return (
    <Dialog open={open} fullWidth>
      <DialogTitle>Global Settings</DialogTitle>
      <DialogContent dividers>
        <div
          className={`${className} !h-max w-full flex-grow-0 gap-4 flex flex-col`}
        >
          <div className="vertical-options">
            <TextField
              disabled
              className="w-full"
              size="small"
              type="date"
              label="Last Updated"
              defaultValue={data.LastUpdate}
              variant="outlined"
            />
            <TextField
              className="w-full"
              size="small"
              type="number"
              label="Max Wager Processed"
              value={data.MaxWager}
              onChange={(event) => handleChange(event, "MaxWager")}
              variant="outlined"
            />
            <TextField
              className="w-full"
              size="small"
              type="date"
              label="Start Date"
              value={data.StartDate}
              onChange={(event) => handleChange(event, "StartDate")}
              variant="outlined"
            />
            <TextField
              className="w-full"
              size="small"
              type="date"
              label="Expiration Date"
              value={data.EndDate}
              onChange={(event) => handleChange(event, "EndDate")}
              variant="outlined"
            />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="!gap-0 vertical-options">
              <h3>Straight Amount Used</h3>
              <FormControl component="fieldset">
                <RadioGroup
                  label
                  value={data.FuncStraightBets}
                  onChange={(event) => {
                    handleChange(event, "FuncStraightBets");
                  }}
                >
                  <FormControlLabel
                    control={<Radio value="M" size="small" color="primary" />}
                    label="Min"
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    control={<Radio value="O" size="small" color="primary" />}
                    label="Original"
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    control={<Radio value="R" size="small" color="primary" />}
                    label="Risk"
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    control={<Radio value="W" size="small" color="primary" />}
                    label="Win"
                    labelPlacement="end"
                  />
                </RadioGroup>
              </FormControl>
            </div>
            <div className="!gap-0 vertical-options">
              <h3>Parlay Amount Used</h3>
              <FormControl component="fieldset">
                <RadioGroup
                  label
                  value={data.FuncParlays}
                  onChange={(event) => {
                    handleChange(event, "FuncParlays");
                  }}
                >
                  <FormControlLabel
                    control={<Radio value="M" size="small" color="primary" />}
                    label="Min"
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    control={<Radio value="O" size="small" color="primary" />}
                    label="Original"
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    control={<Radio value="R" size="small" color="primary" />}
                    label="Risk"
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    control={<Radio value="W" size="small" color="primary" />}
                    label="Win"
                    labelPlacement="end"
                  />
                </RadioGroup>
              </FormControl>
            </div>
            <div className="!gap-0 vertical-options">
              <h3>Teaser Amount Used</h3>
              <FormControl component="fieldset">
                <RadioGroup
                  label
                  value={data.FuncTeasers}
                  onChange={(event) => {
                    handleChange(event, "FuncTeasers");
                  }}
                >
                  <FormControlLabel
                    control={<Radio value="M" size="small" color="primary" />}
                    label="Min"
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    control={<Radio value="O" size="small" color="primary" />}
                    label="Original"
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    control={<Radio value="R" size="small" color="primary" />}
                    label="Risk"
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    control={<Radio value="W" size="small" color="primary" />}
                    label="Win"
                    labelPlacement="end"
                  />
                </RadioGroup>
              </FormControl>
            </div>
            <div className="!gap-0 vertical-options">
              <h3>Teaser Amount Used</h3>
              <FormControlLabel
                control={
                  <Checkbox
                    size="small"
                    checked={data.EnableWinBets}
                    onChange={(event) => {
                      handleChange(
                        undefined,
                        "EnableWinBets",
                        event.target.checked
                      );
                    }}
                    color="primary"
                  />
                }
                label="Won Bets"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    size="small"
                    checked={data.EnableLostBets}
                    onChange={(event) => {
                      handleChange(
                        undefined,
                        "EnableLostBets",
                        event.target.checked
                      );
                    }}
                    color="primary"
                  />
                }
                label="Lost Bets"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    size="small"
                    checked={data.EnablePushBets}
                    onChange={(event) => {
                      handleChange(
                        undefined,
                        "EnablePushBets",
                        event.target.checked
                      );
                    }}
                    color="primary"
                  />
                }
                label="Pushed Bets"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    size="small"
                    checked={data.EnableNABets}
                    onChange={(event) => {
                      handleChange(
                        undefined,
                        "EnableNABets",
                        event.target.checked
                      );
                    }}
                    color="primary"
                  />
                }
                label="No Action Bets"
              />
            </div>
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={() => console.log(data)}>
          Save
        </Button>
        <Button variant="contained" onClick={() => handleOpenDialog(false)}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default GlobalSettings;
